import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[modalWizardStepContent]',
})
export class ModalWizardStepContentDirective {
  viewContainerRef = inject(ViewContainerRef);
}
